var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',{attrs:{"id":"api-error"},domProps:{"innerHTML":_vm._s(_vm.$t('error.api'))}})}
var staticRenderFns = []

export { render, staticRenderFns }